import { render, staticRenderFns } from "./CreateBuildingCard.vue?vue&type=template&id=929ce8ec&scoped=true&"
import script from "./CreateBuildingCard.vue?vue&type=script&lang=js&"
export * from "./CreateBuildingCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateBuildingCard.vue?vue&type=style&index=0&id=929ce8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929ce8ec",
  null
  
)

export default component.exports